import { useAuthStore } from "@lib/auth/authStore";
import { createContext, useEffect, useState } from "react";
import { getMercureClient } from "@/lib/utils/mercure";

export const MercureContext = createContext(null);

/**
 * Lightweight Mercure Provider
 *
 * Only creates and provides the Mercure client.
 * All subscription logic is handled by individual hooks (usePermissionMercure, useUserMercure).
 */
export const MercureProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const userId = useAuthStore((state) => state.userId);

  useEffect(() => {
    let mercureClient = null;

    if (isLoggedIn && userId) {
      mercureClient = getMercureClient();
      setClient(mercureClient);

      if (import.meta.env?.DEV === true) {
        console.log("[MercureProvider] Client initialized for user:", userId);
      }
    } else {
      setClient(null);
    }

    return () => {
      if (mercureClient) {
        mercureClient.disconnect();
        if (import.meta.env?.DEV === true) {
          console.log("[MercureProvider] Client disconnected");
        }
      }
    };
  }, [isLoggedIn, userId]);

  return <MercureContext.Provider value={client}>{children}</MercureContext.Provider>;
};
